<script setup lang="ts">
import LeIconButton from "@dsk/components/IconButton/LeIconButton.vue";
import LeTooltip from "@dsk/components/LeTooltip.vue";
import LeSound from "@dsk/icons/LeSound.vue";
import { computed, ref } from "vue";

import { MatomoHelper } from "@/helpers";
import { MatomoEventAction, MatomoEventCategory } from "@/types";

const props = defineProps<{
  usageLanguage: string;
  pronunciationFileUrl: string;
  type: "headword" | "translation";
}>();

const audioElement = ref<HTMLAudioElement>();

const tooltip = computed<string>(() => {
  if (props.usageLanguage === "de") {
    return "Aussprache hören";
  }

  return "Hør udtale";
});

const onClick = () => {
  MatomoHelper.sendEvent(
    MatomoEventCategory.Results,
    MatomoEventAction.ClickPronunciation,
    `Pronunciation on ${props.type}`
  );

  if (!audioElement.value) {
    audioElement.value = new Audio(props.pronunciationFileUrl);
  }

  audioElement.value.play();
};
</script>

<template>
  <LeTooltip :margin-bottom="8" :text="tooltip">
    <LeIconButton v-bind="$attrs" @click="onClick()">
      <LeSound role="presentation" />
    </LeIconButton>
  </LeTooltip>
</template>
